<template>
  <div class="min-h-screen bg-[#0f172a] relative overflow-hidden">
    <!-- glow -->
    <div
      class="absolute -top-24 -left-24 w-[520px] h-[520px] bg-red-500/10 blur-3xl rounded-full"
    ></div>
    <div
      class="absolute -bottom-24 -right-24 w-[520px] h-[520px] bg-red-500/10 blur-3xl rounded-full"
    ></div>

    <main class="relative">
      <slot />
    </main>
  </div>
</template>

<script setup></script>
